import Cookies from 'js-cookie';
import { getCurrentInstance } from 'vue';

// 是否为中文合规控制白名单用户
export const isChineseComplianceWhiteListUser = async (proxy?: any) => {
    try {
        const { kConf = {} } = (proxy || getCurrentInstance()?.proxy)?.$store?.state?.kConfModule || {};
        const webDid = Cookies.get('webDid');
        if (kConf?.chineseCompliance?.includes?.(webDid)) {
            return true;
        }
        return false;
    } catch {
        return false;
    }
};
